import React from 'react';
import { BaseFeaturedSearchCard } from '../Base';
import { SearchCard } from '../types';
import { Title, GrayUIText, Price, BottomContent } from '../Base/styles';
import {
  BoxConditionIcon,
  TruckIcon,
  MapMarkerIcon,
  CartIcon,
} from '../../../../assets';
import styled from 'styled-components';
import { theme } from '../../../../theme';
import { Pill } from '../../../basePill';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[1].rem};
  margin: ${theme.spacings[2].rem};
  width: 149px;
  justify-content: space-between;
`;

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[2].rem};
  grid-template-rows: minmax(136px, 1fr) repeat(auto-fill, 169px);
`;

const StyledPrice = styled(Price)`
  ${theme.typography.headings[6]['sm-lg']};
  min-height: 34px;
`;

export const BuyNowFeaturedSearchCard: React.FC<SearchCard<'BuyNow'>> = ({
  title,
  condition,
  location,
  isDelivery,
  price,
  data,
  type,
  ...props
}) => {
  return (
    <BaseFeaturedSearchCard {...props}>
      <Content>
        <div>
          <Title>{title}</Title>
        </div>
        <Pill
          backgroundColor={theme.colors.tints.systemBlue[6]}
          icon={CartIcon}
        >
          Buy Now
        </Pill>
        <FlexContainer>
          <StyledPrice>{price}</StyledPrice>
          <BottomContent>
            <GrayUIText>
              <BoxConditionIcon
                width={16}
                fill={theme.colors.neutrals.solidGrays[3]}
              />
              {condition}
            </GrayUIText>
            {(condition as string).length < 13 && (
              <GrayUIText>
                {isDelivery ? (
                  <>
                    <TruckIcon
                      width={16}
                      fill={theme.colors.neutrals.solidGrays[3]}
                    />
                    Delivery
                  </>
                ) : (
                  <>
                    <MapMarkerIcon
                      width={16}
                      fill={theme.colors.neutrals.solidGrays[3]}
                    />
                    {location}
                  </>
                )}
              </GrayUIText>
            )}
          </BottomContent>
        </FlexContainer>
      </Content>
    </BaseFeaturedSearchCard>
  );
};
